import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { DatePicker } from 'antd';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Select from '../../../components/select';
import Editor from "../../../views/combination/editor";

/* import fetch function */
import { CreateEventPoint } from "../../../services/events";

const CreatePointEvent = () => {
    const { RangePicker } = DatePicker;
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        if (name === 'deviceType')
            delete error.codeId;
        else
            delete error[name];

        if (value.length) {
            if (name === 'deviceType')
                _source.codeId = value;
            else
                _source[name] = value;
        }
        
        setError(error);
        setSource(_source);
    };

    const intervalPickerHandler = dates => {
        let _source = Object.assign({}, source);
        
        if (!dates) {
            delete _source.startDate;
            delete _source.endDate;
        }
        else {
            const startDate = `${dates[0].$y}-${dates[0].$M + 1}-${dates[0].$D}`;
            const endDate = `${dates[1].$y}-${dates[1].$M + 1}-${dates[1].$D}`;

            _source.startDate = new Date(startDate).getTime();
            _source.endDate = new Date(endDate).getTime();
        }
        
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {     
            CreateEventPoint(source).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['eventName', 'codeId', 'value', 'reward', 'startDate', 'endDate'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Create Data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='eventName' placeholder='Please enter the event name.' is-required={`${error.eventName}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='pointType' select_all={ false } shadow={ false } required={ error.codeId } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Value</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='value' type='number' min={ 0 } placeholder='Please enter the eligibility threshold.' is-required={`${error.value}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Reward</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='reward' type='number' min={ 0 } placeholder='Please enter the reward points.' is-required={`${error.reward}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Event Date</div>
                        <span className='semicolon'>：</span>
                        <RangePicker className='form-picker' status={ (error['startDate'] || error['endDate']) && 'error' } onChange={ intervalPickerHandler } />
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreatePointEvent;